import React from 'react';
import './Footer.css';
import logo from '../assets/Cores_logo2.png';

const Footer = () => {
  return (
    <footer className="footer-links">
      <div className="footer-row">

        {/* Address and Phone */}
        <div className="footer-info">
          <p>
            <i className="fas fa-map-marker-alt" aria-hidden="true"></i>
            Rua Marcos Portugal 14B, 1495-091, Algés
          </p>
          <p>
            <i className="fas fa-phone" aria-hidden="true"></i>
            +351 966 926 937
          </p>
          <p>
            <a href="mailto:physioperformancecf@gmail.com" aria-label="Email">
              <i className="fas fa-envelope"></i> physioperformancecf@gmail.com
            </a>
          </p>
        </div>

        {/* Social Icons */}
        <div className="footer-info social-icons">
          <a href="https://www.instagram.com/focus.saudeexercicio?igsh=N3k3YTRmMDY4YjBm&utm_source=qr"
             target="_blank"
             rel="noopener noreferrer"
             aria-label="Instagram">
            <i className="fab fa-instagram"></i>
          </a>
          <a
            href="https://www.google.com/maps/place/FOCUS+-+Saúde+e+Exercício/@38.7077607,-9.2295022,17z/data=!3m1!4b1!4m6!3m5!1s0xd1ecd005e553f21:0x8a0ba779d039af1d!8m2!3d38.7077607!4d-9.2295022!16s%2Fg%2F11ychd1b92"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Google Maps - Focus Saúde e Exercício"
          >
            <i className="fab fa-google"></i>
          </a>
        </div>

        {/* Logo */}
        <div className="footer-right-logo">
          <img src={logo} alt="Focus logo" className="footer-logo" />
        </div>

      </div>
    </footer>
  );
};

export default Footer;
